import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getEvents } from '../../../../services/monitor/events/EventsService';
import { ChatType } from '../../../../types/monitor/ChatType';
import { MonitorPeriod } from '../../../../types/monitor/MonitorPeriod';
import { GET_EVENTS } from '../../../query/monitor/events/keys';
import { MonitorEventLogResponse } from '../../../../models/monitor/MonitorEventLogResponse';

export const useGetEvents = (
  projectId: number | null,
  period: MonitorPeriod | null,
  chatType: ChatType | null,
  from: Date | null,
  to: Date | null
) => {
  const queryClient = useQueryClient();
  const queryEnabled = !!projectId && !!period && !!chatType && !!from && !!to;

  const {
    data: events,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery<MonitorEventLogResponse[]>({
    queryKey: [GET_EVENTS, projectId, period, chatType, from, to],
    queryFn: () => getEvents(projectId!, from, to, period!, chatType!),
    staleTime: 1000 * 60 * 60 * 6,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: queryEnabled,
  });

  return {
    events: queryEnabled ? events ?? [] : [],
    isLoading: queryEnabled ? isLoading : false,
    isError: queryEnabled ? isError : false,
    error: queryEnabled ? error : null,
    refetch,
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: [GET_EVENTS, projectId, period, chatType, from, to],
        refetchType: 'active',
      }),
  };
};
